import { useTranslation } from "react-i18next";
import IRequestBodyProps from "./IRequestBodyProps";
import { Col, Row } from "react-bootstrap";
import dayjs from "dayjs";

export default function ReadOnlyBody(props: IRequestBodyProps) {
    const { t } = useTranslation();
    const { request } = props;

    return (
        <Row>
            <Col>
                <Row className="mb-3">
                    <Col>
                        <h2 className="h4">
                            {t("dsar.request.sections.purpose.title")}
                        </h2>
                        <div>
                            {request.purpose}
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <h2 className="h4">
                            {t("dsar.request.sections.custodian.title")}
                        </h2>
                        <ul>
                            <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.custodian.fields.name", { name: request.custodian }) }} />
                            <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.custodian.fields.consent", { consent: request.custodianConsented ? "yes" : "no" }) }} />
                            {
                                !!request.custodianContractStart &&
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.custodian.fields.start", { date: dayjs(request.custodianContractStart).format("DD/MM/YYYY") }) }} />
                            }
                            {
                                !!request.custodianContractEnd &&
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.custodian.fields.end", { date: dayjs(request.custodianContractEnd).format("DD/MM/YYYY") }) }} />
                            }
                            <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.custodian.fields.type", { type: request.custodianContractType }) }} />
                        </ul>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2 className="h4">
                            {t("dsar.request.sections.searchInfo.title")}
                        </h2>
                        {
                            request.type.toLowerCase().startsWith("data") &&
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.searchInfo.fields.dataSearch.start", { date: dayjs(request.dataSearchStart).format("DD/MM/YYYY") }) }} />
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.searchInfo.fields.dataSearch.end", { date: dayjs(request.dataSearchEnd).format("DD/MM/YYYY") }) }} />
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.searchInfo.fields.dataSearch.locations", { locations: request.dataSearchLocations }) }} />
                            </ul>
                        }
                        {
                            request.type.toLowerCase().startsWith("email") &&
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.searchInfo.fields.emailSearch.start", { date: dayjs(request.emailSearchStart).format("DD/MM/YYYY") }) }} />
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.searchInfo.fields.emailSearch.end", { date: dayjs(request.emailSearchEnd).format("DD/MM/YYYY") }) }} />
                                <li dangerouslySetInnerHTML={{ __html: t("dsar.request.sections.searchInfo.fields.emailSearch.address", { email: request.emailSearchAddress }) }} />
                            </ul>
                        }
                    </Col>
                </Row>
                {
                    request.keywords.length > 0 &&
                    <Row>
                        <Col>
                            <h3 className="h5">
                                {t("dsar.request.sections.keywords.title")}
                            </h3>
                            <ul>
                                {
                                    request.keywords.map((k, i) => <li key={i}>{k}</li>)
                                }
                            </ul>
                        </Col>
                    </Row>
                }
            </Col>
        </Row>
    );
};